// infraqap/app/(main)/page.tsx
"use client"

import React, { useState, useEffect } from 'react'; //, Dispatch, SetStateAction, FaProjectDiagram, FaUserPlus
// import InspectorDashboard from '@/components/Dashboards/InspectorDashboard';
import InspecteeDashboard from '@/components/Dashboards/InspecteeDashboard';
import AdminDashboard from '@/components/Dashboards/AdminDashboard';
import { getActiveProjectRole, getActiveProject } from '@/utils/all_apis/project';
import CommonDashboard from '@/components/Dashboards/ProjectsDashboard';
import AllInspections from '@/components/Dashboards/AllInspections';


const LandingPage: React.FC = () => {
  // const [activeProject, setActiveProject] = useState<number | null>(null);
  const [activeDashboard, setActiveDashboard] = useState<'inspector' | 'inspectee' | 'admin' | null>(null);
  const [role, setRole] = useState<string | null>(null);
  const [activeProjectId, setActiveProjectId] = useState(null);
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchActiveProject()
  }, []);

  const fetchActiveProjectRole = async () => {
    const role = await getActiveProjectRole();
    setRole(role);
    if (role) {
      setActiveDashboard(role.toLowerCase() as 'inspector' | 'inspectee' | 'admin');
    }
  };

  const fetchActiveProject = async () => {
    const activeProject = await getActiveProject();
    if(activeProject?.id){
      fetchActiveProjectRole();
    }
    setActiveProjectId(activeProject?.id || null);
    setLoading(false)
  };

  // const handleViewAllProjects = () => {
  //   setActiveProject(null);
  // };
  if(loading){
    return <>Loading...</>
  }

  return (
    <div className="flex flex-col items-center min-h-[calc(100vh-48px)] text-gray-900">
      {activeProjectId ? (
        <div className="w-full">
          {/* <button
            onClick={handleViewAllProjects}
            className="bg-blue-500 text-white px-4 py-2 rounded mb-4"
          >
            View All Projects
          </button> */}
          {activeDashboard === 'inspector' && <AllInspections />}
          {activeDashboard === 'inspectee' && <InspecteeDashboard />}
          {activeDashboard === 'admin' && <AdminDashboard />}
          {activeDashboard === null && <p>No dashboard for role {role}</p>}
        </div>
      ) : (
        <CommonDashboard />
      )}
    </div>
  );
};

export default LandingPage;